import stringifyQueryObjectUtil from 'utils/object/stringify-query'
import pushStateHistoryUtil from 'utils/history/push-state'
import getPathnameLocationUtil from 'utils/location/get-pathname'
import getQueryParamsFromStringObjectUtil from 'utils/object/get-query-params-from-string'
import { PRODUCT_QUERY_PARAMETER } from 'modules/product/constants'
import updateHashLocationUtil from 'utils/location/update-hash'
import logUtil from 'utils/log'
import { CART_HASH_VALUE_ACTION } from 'modules/cart/constants'

/**
 * @param props
 * @param props.selectedVariantId
 */
export default function addSelectedVariantIdToUrlProductUtil (props) {
  logUtil('addSelectedVariantIdToUrlProductUtil').debug('start props=', props)
  const {
    selectedVariantId
  } = props
  const pathname = getPathnameLocationUtil()
  const hash = `#${CART_HASH_VALUE_ACTION.OPEN_QUICK_SHOP_PRODUCT_SIDEBAR}`
  const queryParams = {
    ...getQueryParamsFromStringObjectUtil(),
    [PRODUCT_QUERY_PARAMETER.SELECTED_VARIANT_ID]: selectedVariantId
  }

  const queryParamsStr = stringifyQueryObjectUtil(queryParams)
  pushStateHistoryUtil(`${pathname}?${queryParamsStr}`)
  // Do it this way to trigger the `hashchange` event
  updateHashLocationUtil(hash)
}
